module.exports = __webpack_public_path__ + "static/media/ceo.8ab45703.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/ceo.jpg
// module id = 377
// module chunks = 0